import React, { useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { savesSelector, directorySelector } from 'store/selectors';
import events from 'store/events';

const UserContext = React.createContext();

const UserContextProvider = ({ children }) => {
  const dispatch = useDispatch();
  const saves = useSelector(savesSelector);
  const directory = useSelector(directorySelector);
  const saveList = useMemo(() => Object.entries(saves)
    .map(([id, save]) => ({ id, ...save })),
    [saves]
  );
  const directoryList = useMemo(() => {
    const list = directory.split('\n');
    return list.length && list[0].length ? list : []
  }, [directory]);
  const saveDirectory = useCallback(
    newDirectory => dispatch({
      type: events.addDirectory,
      directory: newDirectory,
    }),
    [dispatch]
  );

  useEffect(() => {
    dispatch({ type: events.loadSaves })
  }, [dispatch]);
  useEffect(() => {
    dispatch({ type: events.loadDirectory })
  }, [dispatch]);

  return (
    <UserContext.Provider value={{
      saves,
      saveList,
      directory,
      directoryList,
      saveDirectory,
    }}>
      {children}
    </UserContext.Provider>
  )
}

export { UserContextProvider, UserContext };
